import { render, staticRenderFns } from "./RentTariffsItem.vue?vue&type=template&id=f07d97ce&lang=pug&"
import script from "./RentTariffsItem.vue?vue&type=script&lang=js&"
export * from "./RentTariffsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports